import styles from "./styles.module.scss";
import logoLeft from "assets/images/logoLeft.png";
import logoRight from "assets/images/logoRight.png";
import LogoLeft1440 from "assets/images/logo/logoLeft1440.png";
import LogoLeft1024 from "assets/images/logo/logoLeft1024.png";
import LogoLeft768 from "assets/images/logo/logoLeft768.png";
import LogoRight1440 from "assets/images/logo/logoRight1440.png";
import LogoRight1024 from "assets/images/logo/logoRight1024.png";
import LogoRight768 from "assets/images/logo/logoRight768.png";

export const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.line} />
      <div className={styles.container}>
        {/* <img className={styles.image} src={logoLeft} alt="cyberfit" /> */}
        <picture>
          <source media="(min-width: 1920px)" srcSet={logoLeft} />
          <source media="(min-width: 1440px)" srcSet={LogoLeft1440} />
          <source media="(min-width: 1024px)" srcSet={LogoLeft1024} />
          <img src={LogoLeft768} alt="" loading="lazy" />
        </picture>
        <div className={styles.textholder}>
          <div className={styles.text}>
            © 2025 КиберФит. Все права защищены.
          </div>
          <div className={styles.text}>
            Концепция веб-дизайна, вдохновленная печатными изданиями, — для
            безупречной редактуры в эпоху цифровых технологий
          </div>
        </div>

        {/* <img className={styles.image} src={logoRight} alt="cyberfit" /> */}
        <picture>
          <source media="(min-width: 1920px)" srcSet={logoRight} />
          <source media="(min-width: 1440px)" srcSet={LogoRight1440} />
          <source media="(min-width: 1024px)" srcSet={LogoRight1024} />
          <img src={LogoRight768} alt="" loading="lazy" />
        </picture>
      </div>
    </div>
  );
};
